import React from 'react';
import PropTypes from 'prop-types';
import { TableWrapper as AppDefsTable } from 'cccisd-laravel-appdefs';

export default class Dashboard extends React.Component {
    static propTypes = {
        type: PropTypes.string,
        routes: PropTypes.object,
        table: PropTypes.object,
    };

    static defaultProps = {
        // default props
    };

    render() {
        const { table } = this.props;
        return (
            <div>
                <div style={{ margin: '0 0 20px 0' }}>
                    <h1>Dashboard</h1>
                </div>
                <div style={{ overflowX: 'scroll' }}>
                    <AppDefsTable table={table} />
                </div>
            </div>
        );
    }
}
